import React, { useState } from "react";
import {
  Dialog,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import InfiniteScroll from "react-infinite-scroller";
import { P_Props } from "./FocusedMarketList.type";
import { FloatingButton, Loading, Notification, Pulse } from "../../../../components";
import moment from "moment";
import { FocusedMarketForm } from "../../..";
import {
  PriorityHigh as PriorityHighIcon,
  Search,
  InfoOutlined
} from "@material-ui/icons";
import CustomButton from "../../../../components/CustomButton";
import { EditIcon } from "../../../../icons";

const FocusedMarketListingPresenter: React.FC<P_Props> = (props) => {
  const [visibleWarning, setVisibleWarning] = useState<boolean>(false);

  const toggleWarningModal = () => {
    setVisibleWarning(!visibleWarning);
  };

  return (
    <>
      <div className="focusedMarket-listing">
        <div className="focusedMarket-listing__content">
          <div className="focusedMarket-listing__content__header">
            <div className="focusedMarket-listing__content__header__title">Focused Market Pages</div>
            <div className="focusedMarket-listing__content__header__actions">
              <TextField
                placeholder="Search by name"
                variant="outlined"
                className="search-input"
                inputProps={{ className: "input" }}
                InputProps={{
                  // style: { fontSize: "1.4rem" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search className="icon" />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  props.onSearch(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="focusedMarket-listing__content--note">
          <InfoOutlined style={{ marginRight: "0.5rem" }} />Maximum number of page: 10</div>
          <div className="focusedMarket-listing__content__list">
            <InfiniteScroll
              useWindow={false}
              pageStart={1}
              initialLoad={false}
              hasMore={!props.fetchedFocusedMarket.loading && props.fetchedFocusedMarket.totalPages > props.fetchedFocusedMarket.page}
              loadMore={() => {
                props.onLoadMore();
              }}
            >
              {!Boolean(props.fetchedFocusedMarket.data.length) && props.fetchedFocusedMarket.loading && <Loading />}
              {props.fetchedFocusedMarket.data.map((page) => {
                return (
                  <div key={page.id} className="focusedMarket-listing__content__list__item">
                    <div
                      className="focusedMarket-text focusedMarket-listing__content__list__info"
                      onClick={() => {
                        props.openFocusedMarketFormModal(page.code);
                      }}
                    >
                      <b>{page.title}</b>
                      <p className="focusedMarket-text focusedMarket-listing__content__list__createAt">
                        {moment(page.publishDate).format("DD/MM/YYYY, hh:mm a")}
                      </p>
                    </div>
                    <div className="focusedMarket-text focusedMarket-listing__content__list__control">
                      <CustomButton onClick={(e) => {
                        e.stopPropagation();
                        props.openFocusedMarketFormModal(page.code);
                      }}
                        color={"transparent"}
                        item={
                          <span>
                            <EditIcon size={[20, 20]} viewBox={[20, 20]} color={"#272B2F"} />
                          </span>
                        } 
                      />
                    </div>
                  </div>
                );
              })}
              {Boolean(props.fetchedFocusedMarket.data.length) && props.fetchedFocusedMarket.loading && <Loading />}
            </InfiniteScroll>
          </div>
        </div>
      </div>
      
      <FloatingButton
        visible={false}
        onClickPrimary={() => {
          if (props.amountPost < 10) {
            props.openFocusedMarketFormModal();
          }
          else {
            toggleWarningModal();
          }
        }}
        btns={[
        ]}
      />

      <Dialog fullScreen open={props.visibleFocusedMarketForm}>
        <FocusedMarketForm
          // languageId={props.visibleFocusedMarketId}
          focusedMarketPageCode={props.visibleFocusedMarketCode}
          onCancel={() => {
            props.closeFocusedMarketFormModal();
          }}
          onComplete_Create={() => {
            props.closeFocusedMarketFormModal();
            props.reloadListingPage();
          }}
          onComplete_Update={() => {
            props.closeFocusedMarketFormModal();
            props.reloadListingPage();
          }}
          onComplete_Delete={() => {
            props.closeFocusedMarketFormModal();
            props.reloadListingPage();
          }}
        />
      </Dialog>

      {/* Warning Modal */}
      <Notification
        className="warning-modal"
        visible={visibleWarning}
        title="Maximum number of pages"
        subTitle="You have reached the maximum number of pages. You cannot create more page."
        icon={
          <Pulse color="yellow">
            <div className="notification-icon-box yellow">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="focusedMarket-listing__status-modal__actions__confirm"
              onClick={toggleWarningModal}
            >
              Ok
            </button>
          </>
        }
      />
    </>
  );
};

export default FocusedMarketListingPresenter;
